import {
  Component,
  inject,
  Injector,
  runInInjectionContext,
} from '@angular/core';
import {
  retriveCurrentRouteData,
  SiaNewRouterService,
  SiaRouteData,
} from '@sia/shared';
import { Subscription } from 'rxjs';
import { SiaPdfViewerComponent } from '../../components/sia-pdf-viewer/sia-pdf-viewer.component';
import { PortalDocumentService } from '../../services/portal-document.service';

@Component({
  selector: 'sia-portal-document-viewer',
  templateUrl: './sia-portal-document-viewer.component.html',
  styleUrls: ['./sia-portal-document-viewer.component.scss'],
  standalone: true,
  imports: [SiaPdfViewerComponent],
})
export class SiaPortalDocumentViewerComponent {
  private routerService = inject(SiaNewRouterService);
  private portalDocumentService = inject(PortalDocumentService);
  private injector: Injector = inject(Injector);

  private _subs: Subscription[] = [];
  pageData: SiaRouteData = {};
  documentBase64: any;

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  loadFile() {
    if (!this.pageData.componentId) {
      return;
    }
    this.portalDocumentService
      .getDocument(this.pageData.componentId ?? '')
      .then((value: any) => {
        this.documentBase64 = value;
      });
  }

  ngAfterViewInit() {
    let s0 = this.routerService.routeChanged$.subscribe(() => {
      var pageData: any = null;
      runInInjectionContext(this.injector, () => {
        pageData = retriveCurrentRouteData() ?? {};
      });
      if (!pageData?.guid || pageData?.guid == this.pageData?.guid) {
        return;
      }
      this.pageData = pageData;
      this.loadFile();
    });
    this._subs.push(s0);
  }
}
